import { data, Link } from 'react-router'
import { type Route } from './+types/index.ts'

export async function loader() {
	const { getPublishedEvents } = await import('#app/models/event.server.ts')
	const events = await getPublishedEvents()
	return data({ events })
}

export default function EventsIndex({ loaderData }: Route.ComponentProps) {
	const { events } = loaderData

	if (events.length === 0) {
		return (
			<div className="px-4 pb-8 pt-4">
				<div className="mx-auto max-w-6xl text-lg sm:px-6 lg:px-8">
					<p className="text-gray-600">
						No upcoming events at this time. Check back soon!
					</p>
				</div>
			</div>
		)
	}

	return (
		<div className="px-4 pb-8 pt-4">
			<div className="mx-auto max-w-6xl sm:px-6 lg:px-8">
				<div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
					{events.map((event) => (
						<Link
							key={event.id}
							to={`/events/${event.slug}`}
							className="group rounded-lg bg-white p-6 shadow transition hover:shadow-md"
						>
							<h3 className="text-xl font-semibold uppercase tracking-wide text-ebhs-blue group-hover:text-ebhs-blue-dark">
								{event.title}
							</h3>
							{event.dates.length > 0 ? (
								<div className="mt-2 text-sm text-gray-600">
									{event.dates.map((d) => (
										<div key={d.id}>
											{new Date(d.date).toLocaleDateString(
												'en-US',
												{
													weekday: 'long',
													month: 'long',
													day: 'numeric',
													year: 'numeric',
													timeZone: 'UTC',
												},
											)}
										</div>
									))}
								</div>
							) : null}
							{event.images[0] ? (
								<div className="mt-3">
									<img
										src={`/resources/images?objectKey=${encodeURIComponent(event.images[0].objectKey)}`}
										alt={event.images[0].altText ?? ''}
										className="w-full rounded-md"
									/>
								</div>
							) : null}
						</Link>
					))}
				</div>
			</div>
		</div>
	)
}
